/**
 * Lifts the ```draft block out of a support answer so it can be reviewed on its own.
 *
 * It is separated from the diagnosis for one reason: the draft is the only part that could ever
 * reach a customer, so it has to be readable as a unit before anyone sends it.
 */
export function extractDraft(content) {
  const match = content.match(/```draft\s*([\s\S]*?)```/);
  if (!match) return {
    body: content,
    draft: null
  };
  const draft = match[1].trim();
  if (!draft) return {
    body: content,
    draft: null
  };
  return {
    body: content.replace(match[0], '').replace(/\n{3,}/g, '\n\n').trim(),
    draft
  };
}